import { Suspense } from 'react';

import { TAccount } from '@helpers/Accounts/accounts.types';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { H2, Text } from '@ui';
import { FormattedMessage } from 'react-intl';

import { BackToDashboard } from './BackToDashboard';
import { TopupRequestDE } from './TopupRequestDE';
import { useGetTopupRequestData } from './useGetTopupRequestData';
import FallbackErrorModal from '../modals/fallbackErrorModal/FallbackErrorModal';
import { TopUpForm } from '../multiLoanDashboard/NewOutstandingView/TopUpForm/TopUpForm';
import MainContentPending from '../pageStructure/mainContentPending';

export const TopupRequest = () => {
    const location = getCurrentLocation();

    const accountId: TAccount['account_id'] = getQueryParameter(
        location,
        'accountId'
    );

    if (!accountId) {
        return <FallbackErrorModal />;
    }
    return (
        <Suspense fallback={<MainContentPending />}>
            <TopupForm accountId={accountId} />
        </Suspense>
    );
};

const TopupForm = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    const { isPreApproved, approvalAmount } = useGetTopupRequestData(accountId);

    if (getCountry() === 'DE') {
        return <TopupRequestDE accountId={accountId} />;
    }

    return (
        <div className="bg-structure-100 px-[15%] py-xl max-sm:px-[5%]">
            <TopUpForm
                accountId={accountId}
                formHeader={
                    <>
                        <BackToDashboard />
                        <H2 className="text-xl font-bold">
                            <FormattedMessage
                                id="_.outstanding_view.preApprovedMoreFundsCTA"
                                defaultMessage="Request more funds"
                            />
                        </H2>
                        {isPreApproved && (
                            <Text className="mb-m text-m">
                                <FormattedMessage
                                    id="_.outstanding_view.requestMoreFundsHeading"
                                    defaultMessage="You're already approved for {amount}. Approval to more funds is subject to credit review."
                                    values={{
                                        amount: (
                                            <FormattedCurrency
                                                value={approvalAmount}
                                            />
                                        )
                                    }}
                                />
                            </Text>
                        )}
                    </>
                }
            />
        </div>
    );
};
